import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { SettingsNestedMenu } from 'src/editor/layout/sidebar/settings/settings-nested-menu'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { ImageControl } from 'src/editor/shared/settings/controls/image-control'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import { EntityTypographyGroup } from 'src/editor/shared/settings/wrappers/entity-and-website-typography-group/entity-typography-group'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'

export interface WebsiteLogoSettingsProps {
  entity: WebsiteLogoInterface
}

export const WebsiteLogoSettings = ({ entity }: WebsiteLogoSettingsProps) => {
  const updateProp = useUpdateProp(entity)
  const { t } = useTranslation()
  return (
    <>
      <GroupTitle withoutHorizontalLine>{t('typography')}</GroupTitle>
      <TextInputControl
        update={updateProp('logoText')}
        value={entity.logoText}
        placeholder={t('website_settings.sidebar.logo.label')}
        wrapperProps={{
          labelText: t('website_settings.sidebar.logo.add_text'),
        }}
        directionRow
      />
      <SettingsNestedMenu
        menuButtonLabel={t('settings.sidebar.customize')}
        menuTitle={t('entity_settings.websitelogo.header')}
      >
        <GroupTitle withoutHorizontalLine>{t('typography')}</GroupTitle>
        <TextInputControl
          update={updateProp('logoText')}
          value={entity.logoText}
          placeholder={t('website_settings.sidebar.logo.label')}
          wrapperProps={{
            labelText: t('website_settings.sidebar.logo.add_text'),
          }}
          directionRow
        />
        <EntityTypographyGroup entity={entity} hideTitle isFirst />
        <ColorPickerControl
          label="website_settings.sidebar.logo.text_color"
          update={updateProp('textColor')}
          color={entity.textColor}
          singleColorMode
        ></ColorPickerControl>
      </SettingsNestedMenu>

      <GroupTitle>{t('website_settings.sidebar.logo.title.image')}</GroupTitle>
      <ImageControl
        className="mt-3"
        label="website_settings.sidebar.logo.label"
        fileId={entity.logoFileId}
        updateBackgroundFileId={updateProp('logoFileId')}
      />
      <ImageControl
        className="mt-3"
        label="website_settings.sidebar.logo.mobile_image"
        fileId={entity.mobileLogoFileId}
        updateBackgroundFileId={updateProp('mobileLogoFileId')}
      />
      {(entity.logoFileId || entity.mobileLogoFileId) && (
        <p className="mt-3! text-M text-textTertiary">
          {t('website_settings.sidebar.logo.description')}
        </p>
      )}

      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}
